/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentCategoryChangeOrderDto } from '../../models/document-category-change-order-dto';

export interface AdminDocumentTemplateCategoryControllerUpdateOrder$Params {
      body: Array<DocumentCategoryChangeOrderDto>
}

export function adminDocumentTemplateCategoryControllerUpdateOrder(http: HttpClient, rootUrl: string, params: AdminDocumentTemplateCategoryControllerUpdateOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, adminDocumentTemplateCategoryControllerUpdateOrder.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

adminDocumentTemplateCategoryControllerUpdateOrder.PATH = '/api/document-template-category-admin/order';
